// extracted by mini-css-extract-plugin
module.exports = {"container":"Chats_container__3hRVS","container--outless":"Chats_container--outless__YeGP4","title":"Chats_title__2p6Jo","commentInput":"Chats_commentInput__22eVC"};